export type AppModule = {
  id: string;
  title: string;
  path: string;
  group: 'workspace' | 'system';
};

export const appModules: readonly AppModule[] = [
  {id: 'tasks', title: '任务管理', path: '/tax-assistant/tasks', group: 'workspace'},
  {id: 'space', title: '空间', path: '/tax-assistant/space', group: 'workspace'},
  {id: 'enterprise-space', title: '团队空间', path: '/tax-assistant/enterprise-space', group: 'workspace'},
  {id: 'team-join', title: '加入团队', path: '/tax-assistant/team-join', group: 'workspace'},
  {id: 'plans', title: '台账方案', path: '/tax-assistant/plans', group: 'workspace'},
  {id: 'declarations', title: '报关单识别', path: '/tax-assistant/declarations', group: 'workspace'},
  {id: 'invoices', title: '发票识别', path: '/tax-assistant/invoices', group: 'workspace'},
  {id: 'matching', title: '匹配核对', path: '/tax-assistant/matching', group: 'workspace'},
  {id: 'ledger', title: '台账生成', path: '/tax-assistant/ledger', group: 'workspace'},
  {id: 'suppliers', title: '厂家管理', path: '/tax-assistant/suppliers', group: 'workspace'},
  {id: 'rebate', title: '退税申报', path: '/tax-assistant/rebate', group: 'workspace'},
  {id: 'archive', title: '资料归档', path: '/tax-assistant/archive', group: 'workspace'},
  {id: 'legal-review', title: '合同文件审核', path: '/tax-assistant/legal-review', group: 'workspace'},
  {id: 'legal-litigation', title: '诉讼台账管理', path: '/tax-assistant/legal-litigation', group: 'workspace'},
  {id: 'profile', title: '个人主页', path: '/tax-assistant/profile', group: 'system'},
  {id: 'integrations', title: '外部接入', path: '/tax-assistant/integrations', group: 'system'},
  {id: 'organization-settings', title: '账号安全', path: '/tax-assistant/organization', group: 'system'},
  {id: 'enterprise-account', title: '团队空间管理', path: '/tax-assistant/enterprise-account', group: 'system'},
  {id: 'billing', title: '收费中心', path: '/tax-assistant/billing', group: 'system'},
];

export function findAppModule(pathname: string): AppModule | undefined {
  const normalized = pathname.replace(/\/$/, '') || '/';
  const exact = appModules.find((item) => item.path === normalized);
  if (exact) return exact;
  // 合同审核采用模块内多页面工作流，所有子路由仍归属于同一专业模块。
  if (normalized.startsWith('/tax-assistant/legal-review/')) {
    return appModules.find((item) => item.id === 'legal-review');
  }
  if (normalized.startsWith('/tax-assistant/legal-litigation')) {
    return appModules.find((item) => item.id === 'legal-litigation');
  }
  if (normalized === '/tax-assistant/team-space') {
    return appModules.find((item) => item.id === 'enterprise-space');
  }
  return undefined;
}
